const payloadsStore = new Map();
const listenersStore = new Map();

export const addListener = (
  eventType,
  listenerFn,
  { runLostEmits = false } = {}
) => {
  if (!listenersStore.has(eventType)) {
    listenersStore.set(eventType, []);
  }

  const storedListeners = listenersStore.get(eventType);

  listenersStore.set(eventType, [...storedListeners, listenerFn]);

  if (runLostEmits && payloadsStore.has(eventType)) {
    payloadsStore.get(eventType).forEach(listenerFn);
  }

  document.addEventListener(eventType, listenerFn);
};

export const emitEvent = (
  eventType,
  payload = {},
  { storeDispatch = false } = {}
) => {
  if (storeDispatch) {
    if (!payloadsStore.has(eventType)) {
      payloadsStore.set(eventType, []);
    }

    const storedPayloads = payloadsStore.get(eventType);

    payloadsStore.set(eventType, [...storedPayloads, payload]);
  }

  let event;

  if (Object.keys(payload).length === 0) {
    event = new CustomEvent(eventType, { detail: null });
  } else {
    event = new CustomEvent(eventType, { detail: payload });
  }
  document.dispatchEvent(event);
};

export const removeListener = (eventType, listenerFn) => {
  document.removeEventListener(eventType, listenerFn);
};

export const removeListeners = (eventType) => {
  if (listenersStore.has(eventType)) {
    listenersStore.get(eventType).forEach((listenerFn) => {
      document.removeEventListener(eventType, listenerFn);
    });
  }
};
